import { useMutation, useQueryClient } from '@tanstack/react-query';
import { routeQueryKeys, Routes } from '#api';
import { makeRouteQueryOptions } from '#api/routes.queries.ts';

export function useAddRoute() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: Routes.addRoute,
    onSuccess(data) {
      void queryClient.invalidateQueries({ queryKey: routeQueryKeys.lists() });
      queryClient.setQueryData(makeRouteQueryOptions(data.id).queryKey, { data });
    },
  });
}

export function useEditRoute() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: Routes.editRoute,
    onSuccess(data) {
      void queryClient.invalidateQueries({ queryKey: routeQueryKeys.lists() });
      queryClient.setQueryData(makeRouteQueryOptions(data.id).queryKey, { data });
    },
  });
}
